import { Component, OnInit } from '@angular/core';
import {SessionService} from '../../services/session.service';
import {environment} from '../../../environments/environment';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public appName = environment.app_name;
  constructor(
    public authService: SessionService,
  ) { }

  ngOnInit(): void {
  }

  logout(): void {
    this.authService.logout();
  }
}
